/**
 * PeriodModeSelector - Segmented control for selecting period mode
 *
 * Allows switching between Annual, Quarterly, and Monthly views
 * in the Analyst Bench financial tables.
 */

import { useTranslation } from 'react-i18next';
import type { PeriodMode } from '../../types/periodMode';
import { PERIOD_MODE_CONFIG, PERIOD_MODES } from '../../types/periodMode';
import './PeriodModeSelector.css';

interface PeriodModeSelectorProps {
  mode: PeriodMode;
  onChange: (mode: PeriodMode) => void;
  disabled?: boolean;
}

export default function PeriodModeSelector({
  mode,
  onChange,
  disabled = false,
}: PeriodModeSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className={`period-mode-selector ${disabled ? 'disabled' : ''}`}>
      {PERIOD_MODES.map((m) => {
        const config = PERIOD_MODE_CONFIG[m];
        return (
          <button
            key={m}
            className={`mode-button ${mode === m ? 'active' : ''}`}
            onClick={() => onChange(m)}
            disabled={disabled}
            title={t(config.description)}
          >
            {t(config.label)}
          </button>
        );
      })}
    </div>
  );
}
